<template>
  <div>
    <transition name="fade">
      <div class="panel panel-default" v-if="message.length > 0">
        <div class="panel-body">{{ message }}</div>
      </div>
    </transition>
    <div class="panel panel-default">
      <div class="panel-heading">Editer menu</div>
      <div class="panel-body">
        <loader-box v-if="loading"/>
        <form method="POST" action="#" @submit.prevent="submitMenu">
          <div class="form-group">
            <label for="name" class="control-label">Nom</label>
            <input autofocus type="text" name="name" id="name" class="form-control" v-model="menu.name"/>
          </div>
          <div class="form-group" style="display: none">
            <label for="slug" class="control-label">Slug</label>
            <input type="text" name="slug" id="slug" placeholder="(optionnel. Générer à partir du nom)"
                   class="form-control" v-model="menuSlug"/>
          </div>
          <div class="form-group">
            <label for="restaurant_id" class="control-label">Resto</label>
            <select v-model="menu.restaurant_id" name="restaurant_id" id="restaurant_id" class="form-control">
              <option :value="restaurant.id" v-for="restaurant in restaurants">{{ restaurant.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="menu_type" class="control-label">Type</label>
            <select name="menu_type" id="menu_type" class="form-control" v-model="menu.menu_type">
              <option :value="0">Déjeuner</option>
              <option :value="1">Diner</option>
              <option :value="2">FastFood</option>
            </select>
          </div>
          <div class="form-group">
            <div class="checkbox">
              <label>
                <input type="checkbox" name="remember" v-model="menu.status"> Disponible ?
              </label>
            </div>
          </div>
          <div class="form-group" v-show="menu.menu_type !== 2">
            <label for="at" class="control-label">Date</label>
            <input type="text" name="at" id="at" class="form-control date-picker" v-model="menu.at"/>
          </div>
          <div class="form-group" v-show="menu.menu_type === 2 || privateRestaurantIDs.includes(menu.restaurant_id)">
            <label for="price" class="control-label">Prix en FCFA</label>
            <input type="text" name="price" id="price" class="form-control" v-model="menu.price"/>
          </div>
          <div class="form-group" v-show="menu.menu_type === 2 || privateRestaurantIDs.includes(menu.restaurant_id)">
            <label for="shipment_fee" class="control-label">Frais de livraison en FCFA</label>
            <input type="text" name="shipment_fee" id="shipment_fee" class="form-control" v-model="menu.shipment_fee"/>
          </div>
          <button class="btn-block btn btn-primary">Enregistrer <i class="fa fa-save"></i></button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {handleErrors, resetErrors} from '../../form'
  import AppApiResponse from "../../AppApiResponse";
  import LoaderBox from '../Loader/LoaderBox'
  import appAxios from '../../app-axios.js'
  import Swal from 'sweetalert2'

  export default {
    props: {
      menuProp: {type: Object},
      menuUrl: {type: String},
      restaurantUrl: {type: String},
    },
    components: {LoaderBox},
    data () {
      return {
        restaurants: [],
        loading: false,
        restaurantLoading: false,
        message: '',
        menu: {
          name: '',
          slug: '',
          price: 0,
          menu_type: 0,
          at: '',
          restaurant_id: 0,
          shipment_fee: 0,
          status: false
        }
      }
    },
    computed: {
      menuSlug: {
        get () {
          return this.menu.name.toLowerCase().split(' ').join('-')
        },
        set (value) {
          this.menu.slug = value
        }
      },
      privateRestaurantIDs () {
        return this.restaurants
          .filter(restaurant => restaurant.is_private)
          .map(restaurant => restaurant.id)
      }
    },
    methods: {
      loadRestaurants () {
        this.restaurantLoading = true
        appAxios(this.restaurantUrl)
          .then(response => {
            this.restaurants = (response.data.hasOwnProperty('data'))
              ? response.data.data
              : response.data
          })
          .catch(error => {

          })
          .then(_ => this.restaurantLoading = false)
      },
      // loadMenu (id) {
      //   return new Promise((resolve, reject) => {
      //     appAxios.get(this.menuUrl + '/' + id)
      //       .then(response => {
      //         let apiResponse = new AppApiResponse(response)
      //         if (apiResponse.isSuccess()) {
      //           resolve(apiResponse.getData())
      //         } else {
      //           reject(apiResponse)
      //         }
      //       })
      //       .catch(error => reject(new AppApiResponse(error)))
      //   })
      // },
      submitMenu () {
        resetErrors(Object.keys(this.menu), {
          classList: ['has-error', 'has-success']
        })
        this.loading = true
        appAxios.put(this.menuUrl + '/' + this.menu.id, this.menu)
          .then(response => {
            let apiResponse = new AppApiResponse(response)
            this.message = apiResponse.getMessage()
            Swal({
              type: 'success',
              title: apiResponse.getMessage(),
              timer: 2000,
              onClose () {
                window.location = '/menu'
              }
            })
          })
          .catch(error => {
            let apiResponse = new AppApiResponse(error)
            handleErrors(apiResponse.getData(), Object.keys(this.menu), {
              feedbackClass: 'help-block',
              errorClass: 'has-error'
            })
          })
          .then(() => this.loading = false)
      }
    },
    mounted () {
      this.loadRestaurants()
      this.menu = Object.assign({}, this.menu, this.menuProp)
      // this.menu.menu_type = +this.menu.menu_type
      let instance = flatpickr(this.$el.querySelector('#at'), {
        enableTime: false,
        dateFormat: 'Y-m-dTH:i:ss',
        altInput: true,
        altFormat: 'F j, Y',
        defaultDate: 'today'
      })
      instance.setDate(this.menu.at)
      // no need to do all the loading stuff since it's provided as prop
      // this.loading = true
      // this.loadMenu()
      //   .then(menu => {
      //     this.menu = Object.assign({}, this.menu, menu)
      //   })
      //   .catch(apiResponse => {
      //     console.error(apiResponse)
      //     Swal('Une erreur est survenue lors du chargement du menu à éditer', 'error')
      //   })
      //   .then(_ => this.loading = false)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/component/Menu/MenuEdit.vue